import { render, staticRenderFns } from "./DocumentViewCellRenderer.vue?vue&type=template&id=6d1ce4c6&scoped=true"
import script from "./DocumentViewCellRenderer.vue?vue&type=script&lang=js"
export * from "./DocumentViewCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ce4c6",
  null
  
)

export default component.exports